<nav
  class="now-breadcrumb"
  aria-label="breadcrumb"
  [ngClass]="{ 'now-expanded': expanded }"
  (focus)="expanded = true"
  (blur)="expanded = false"
>
  <ol>
    <li>
      <a href="http://www.mein-now.de">Startseite</a>
    </li>
    @for (breadcrumb of breabcrumbList; track trackByIndex(i, breadcrumb); let i = $index) {
      <li>
        @if (i === breabcrumbList.length - 1) {
          <span aria-current="page">
            {{ breadcrumb.title }}
          </span>
        } @else {
          <a
            [routerLink]="[breadcrumb.link]"
            queryParamsHandling="merge"
            [queryParams]="queryParams$ | async"
            >{{ breadcrumb.title }}</a
          >
        }
      </li>
    }
  </ol>
</nav>
